import { SYSConfig, SYSScreen, ovl } from "../"
import type { _ScreenState } from "./sysbaseelement"
export type HookScreenRefresh_Type = {
  suppressFeedbackSnack?: boolean
  instance?: string
  triggeredFromRefreshMenu?: boolean
}
export const ScreenRefresh = async (
  screen?: SYSScreen,

  options?: HookScreenRefresh_Type
) => {
  let screensFunctions = ovl.getActions().app.screens
  let screenCurrentState = ScreenCurrentState()
  if (!screen) {
    screen = screenCurrentState.screen
  }
  let instance = options?.instance
  if (instance === undefined) {
    instance = screenCurrentState.instance
  }
  if (screensFunctions[screen].hooks["HookScreenRefresh"]) {
    let context = instance
    await screensFunctions[screen].hooks["HookScreenRefresh"](<
      HookScreenRefresh_Type
    >{
      instance: context,
      suppressFeedbackSnack: options?.suppressFeedbackSnack,
      triggeredFromRefreshMenu: options?.triggeredFromRefreshMenu,
    })
  }
}

export type NavigateToScreenOptionsType = {
  instance: any
}

export const ScreenCurrent = (): SYSScreen => {
  return ovl.getState().ovl.screens.nav.nextScreen
}

export const ScreenCurrentState = (): _ScreenState => {
  let nav = ovl.getState().ovl.screens.nav
  let screen = nav.nextScreen
  let instance = nav.nextScreenInstance
  return ScreenState(screen, instance)
}

export const ScreenState = (screen: SYSScreen, instance?: string) => {
  if (!instance) {
    instance = screen
  }
  return ovl.getState().ovl.screens.screens[screen]?.instance?.[instance]
}

export const ScreenNavigateTo = async (
  screen: SYSScreen,
  options?: NavigateToScreenOptionsType
) => {
  await ovl.getActions().ovl.navigation._Navigate({
    screen,
    navigateBack: false,
    options,
  })
}
export const ScreenNavigateBack = async () => {
  let state = ovl.getState()
  // let idx1 = 1
  // let idx2 = 2
  // //if we are on a no history screen
  // if (SYSConfig.app.screens[ScreenCurrent()]?.noHistory === true) {
  //   idx1--
  //   idx2--
  // }

  let screenState = ScreenCurrentState()
  let screensFiltered = state.ovl.screens.nav.screensHistory.filter(
    (f) =>
      !(f.screen === screenState.screen && f.instance === screenState.instance)
  )
  if (screensFiltered.length > 0) {
    let nextScreen = screensFiltered[screensFiltered.length - 1]
    await ovl.getActions().ovl.navigation._Navigate({
      screen: nextScreen.screen,
      navigateBack: true,
      options: { instance: nextScreen.instance },
    })
  }
}

export const ScreenIsNavigating = () => {
  return ovl.getState().ovl.screens.nav.isNavigating
}

export const ScreenLock = (
  screen: SYSScreen,
  lock: boolean,
  instance = undefined
) => {
  ovl.getActions().ovl.screen._ScreenSetLock({
    screen,
    locked: lock,
    instance,
  })
}
